import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Navbar.css";
/* The topbar sits on Oxford Blue in all three dashboards, so the white
   lock-up is the correct mark here — the colour version was invisible. */
import logo from "./../../assets/Images/LOGOS/Docity_Logo_White.png";
import AuthService from "../../Services/AuthService";
import userProfile from "./../../assets/Images/Navbar/user.png";
import phoneCall from "./../../assets/Images/phone-call2.png";
import { AiOutlineEye, AiOutlineEyeInvisible, AiOutlinePhone } from "react-icons/ai";
import { Settings, LogOut } from 'lucide-react';
import loader from '../../assets/Images/Request_Property/Loader.gif';
import upload from "./../../assets/Images/Request_Property/upload.png";
import { FaTrashAlt } from 'react-icons/fa';
import close from "./../../assets/Images/Request_Property/close.png";

// import Modal from '../Modal/Modal';
import { Button, Modal, Form } from "react-bootstrap";
import PropertiesService from "../../Services/PropertiesService";
import Modalw from "../Modal/Modal";
import LiveChat from "../liveChatModule/liveChatModule";
import { getDocumentPreviewUrl } from '../../utils/fileHelpers';
import { getVersionLabel } from "../../config/appMeta";
import { TEXTS } from "../../constants/texts";

const Navbar = () => {
  const [ModalOpen, setModalOpen] = useState(false);
  const [isSignup, setIsSignup] = useState("firstpage");
  const openModal = (view = "login") => {
    setIsSignup(view);
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setIsSignup("firstpage");
  };
  const [otpVerification, setOtpVerification] = useState(false);
  const [token, setToken] = useState("");
  const [userDetails, setuserDetails] = useState();
  const [dropDown, setDropDown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [editProfile, setEditProfile] = useState(false);
  const [userData, setuserData] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [Error, setError] = useState([]);
  const [password, setPassword] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const validatePassword = (value) =>
    /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/.test(value);
  const handleNewPasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);
    if (!validatePassword(value)) {
      setError({
        newPassword:
          "Password must be at least 8 characters long, include one number and one special character.",
      });
    } else {
      setError("");
    }
  };
  const [newPassword, setNewPassword] = useState("");
  const imageUploadRef = useRef(null);


  const [error, seterror] = useState({ image: "" });

  const changePassword = async () => {
    if (!password) {
      setError({ password: "Enter Password" });
      setTimeout(() => {
        setError([]);
      }, 4000);
    } else if (!newPassword) {
      setError({ newPassword: "Enter New Password" });
      setTimeout(() => {
        setError([]);
      }, 4000);
    } else if (password === newPassword) {
      setError({ match: "New password cannot be the same as the old password." });
      setTimeout(() => {
        setError([]);
      }, 4000);
    } else {
      if (Error.length === 0) {
        let obj = {
          email: userDetails.email,
          oldPassword: password,
          newPassword: newPassword,
        };
        try {
          const response = await AuthService.UpdatePassword(obj);
          if (response.data !== undefined) {
            alert("Password updated successfully.");
            setEditProfile(false);
          } else {
            setError({ match: "Please enter correct password" });
            setTimeout(() => {
              setError([]);
            }, 2000);
          }
        } catch (error) {
        }

      }
    }
  };

  const onLoad = () => {
    setIsLoading(false);
    setHasError(false);
  };

  const onError = () => {
    setIsLoading(false);
    setHasError(true);
  };
  useEffect(() => {
    // localStorage.removeItem("userDetails");

    setToken(localStorage.getItem("token") || "");
    setuserDetails(JSON.parse(localStorage.getItem("userDetails")));
  }, []);
  const getProfileImage = (img) => {
    if (!img || img === "null" || img === "undefined" || (typeof img === "string" && img.trim() === "")) {
      return userProfile;
    }
    return img;
  };

  const navigate = useNavigate();
  const handleEditProfileClose = () => {
    setEditProfile(false);
  };
  const handleEdit = () => {
    navigate('/profile');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest(".user-icon") === null) {
        setDropDown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const [ColorChange, setColorChange] = useState("Edit Account");

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  const handleEditClose = () => {
    setEditProfile(false);
    // window.location.reload();
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("image", file);
    setImageLoading(true);

    try {
      const response = await PropertiesService.UploadFiles(formData);
      if (response?.Location) {
        setUploadedImageUrl(response.Location);
      } else {
        setError({ image: "Upload failed. Please try again." });
      }
    } catch (error) {
      console.error("Image upload error:", error);
      setError({ image: "Upload error. Please try again." });
    } finally {
      setImageLoading(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
    }
  };
  const editUser = async () => {
    const phonePattern = /^\d{10}$/;

    if (!userData.name) {
      setError({ name: "Enter Name" });
      setTimeout(() => setError([]), 2000);
    } else if (!userData.phone) {
      setError({ phone: "Enter phone" });
      setTimeout(() => setError([]), 2000);
    } else if (!phonePattern.test(userData.phone)) {
      setError({ phoneNumber: "Enter a valid 10-digit phone number." });
      setTimeout(() => setError([]), 2000);
    }
    // else if (!uploadedImageUrl) {
    //   setError({ image: "Please upload an image" });
    //   setTimeout(() => setError([]), 2000);
    // }
    else if (!uploadedImageUrl && !userData.image) {
      setError({ image: "Please upload an image" });
      setTimeout(() => setError([]), 4000);
    }

    else {
      const obj = {
        userId: userDetails.user_id,
        name: userData.name,
        firstName: userData.firstName,
        middleName: userData.middleName,
        lastName: userData.lastName,
        phoneNumber: userData.phone,
        countryCode: userData.countryCode,
        image: uploadedImageUrl || userData.image,
        docs: "",
      };

      try {
        const response = await AuthService.editDoCityUserData(obj);

        localStorage.setItem("userDetails", JSON.stringify(response.data.data));
        alert("Details updated successfully.");
        window.location.reload();
        setEditProfile(false);
      } catch (error) {
        console.error(error);
      }
    }
  };


  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userDetails");
    setToken("");
    setuserDetails(null);
    navigate("/");
    refresh();
  };
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    if (!validatePassword(value)) {
      setError({
        password:
          "Password must be at least 8 characters, include one number and one special character.",
      });
    } else {
      setError("");
    }
  };
  // const handleChange = (e) => {
  //     const { name, value } = e.target
  //     setuserData({
  //         ...userData,
  //         [name]: value
  //     })
  // }
  const handleChange = (e) => {
    const { name, value } = e.target;

    setuserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Validation for phone number
    if (name === "phone") {
      if (!value) {
        setError((prev) => ({
          ...prev,
          phone: "Phone Number is invalid",
          phoneNumber: "",
        }));
      } else if (value.length !== 10) {
        setError((prev) => ({
          ...prev,
          phoneNumber: "Phone number should be 10 digits",
          phone: "",
        }));
      } else {
        setError((prev) => ({ ...prev, phone: "", phoneNumber: "" }));
      }
    }
  };

  const handleRemove = (index) => {
    const updatedFiles = [...uploadedFiles];
    updatedFiles.splice(index, 1);
    setUploadedFiles(updatedFiles);
  };
  const refresh = () => {
    window.location.href = '/';
    navigate('/');
  };
  return (
    <>
      <div className="container-fluid navbackgroud">
        {/* Navbar */}
        <nav className="navbar navbar-expand-lg navbar-light">
          <div className="container-fluid navbar-background">
            <NavLink className="navbar-brand-text" to="/" onClick={() => refresh()}>
              <img src={logo} alt="DoCity" />
              <span className="navbar-role">
                <span className="navbar-role__dot" />
                Property Owner
              </span>
            </NavLink>
            <button
              className="navbar-toggler"
              type="button"
              onClick={toggleNavbar}
              aria-label={isOpen ? "Close navigation" : "Open navigation"}
              aria-expanded={isOpen}
              aria-controls="mobile-navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse d-none d-lg-flex" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <ul className="navbar-nav navbar-centered-links">
                <li className="nav-item">
                  <NavLink className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} to="/" onClick={() => refresh()}>
                    Home
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} to="/about">
                    About Us
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} to="/faq">
                    FAQ's
                  </NavLink>
                </li>
                {token && (
                  <li className="nav-item">
                    <NavLink className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} to="/reqProperty">
                      Docity Customer Properties
                    </NavLink>
                  </li>
                )}
                {token && (
                  <li className="nav-item">
                    <NavLink className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} to="/KYPList">
                      KYP
                    </NavLink>
                  </li>
                )}
              </ul>

              <div className="navbar-right-actions">
                {token ? (
                  <div
                    className="user-icon"
                    role="button"
                    tabIndex={0}
                    aria-haspopup="menu"
                    aria-expanded={dropDown}
                    onClick={() => setDropDown(!dropDown)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setDropDown(!dropDown);
                      }
                      if (e.key === "Escape") setDropDown(false);
                    }}
                  >
                    <div className="profile-img-wrapper">
                      <img
                        src={getProfileImage(userDetails?.image)}
                        alt=""
                        className="userimage"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = userProfile;
                        }}
                      />
                    </div>
                    <p className="user-name">{userDetails?.name}</p>
                    {dropDown && (
                      <div className="dropdown-menu" role="menu">
                        <div className="dropdown-menu-item" role="menuitem" onClick={() => handleEdit()}>
                          <Settings size={16} className="dropdown-icon" />
                          <span>Edit Profile</span>
                        </div>
                        <div
                          className="dropdown-menu-item dropdown-menu-item--danger"
                          role="menuitem"
                          onClick={handleLogout}
                        >
                          <LogOut size={16} className="dropdown-icon" />
                          <span>Log out</span>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <button className="login-btn-navbar" onClick={() => openModal("firstpage")}>
                    Login / Register
                  </button>
                )}
              </div>
            </div>

          </div>
        </nav>

        {/* 🔥 MOBILE MENU (OUTSIDE NAVBAR) */}
        {isOpen && (
          <div className="mobile-menu-panel d-lg-none" id="mobile-navigation">
            <ul className="mobile-menu-list">
              <li>
                <NavLink
                  className={({ isActive }) => `mobile-link${isActive ? " active" : ""}`}
                  to="/"
                  onClick={() => { setIsOpen(false); refresh(); }}
                >
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) => `mobile-link${isActive ? " active" : ""}`}
                  to="/about"
                  onClick={() => setIsOpen(false)}
                >
                  About Us
                </NavLink>
              </li>

              <li>
                <NavLink
                  className={({ isActive }) => `mobile-link${isActive ? " active" : ""}`}
                  to="/faq"
                  onClick={() => setIsOpen(false)}
                >
                  FAQ's
                </NavLink>
              </li>

              {token && (
                <li>
                  <NavLink
                    className={({ isActive }) => `mobile-link${isActive ? " active" : ""}`}
                    to="/reqProperty"
                    onClick={() => setIsOpen(false)}
                  >
                    Docity Customer Properties
                  </NavLink>
                </li>
              )}

              {token && (
                <li>
                  <NavLink
                    className={({ isActive }) => `mobile-link${isActive ? " active" : ""}`}
                    to="/KYPList"
                    onClick={() => setIsOpen(false)}
                  >
                    KYP
                  </NavLink>
                </li>
              )}

              {/* 👤 USER ACTIONS (MOBILE ONLY) */}
              {token && (
                <>
                  <li className="mobile-divider" />

                  <li className="mobile-user-info">
                    <img
                      src={getProfileImage(userDetails?.image)}
                      alt="profile"
                      className="mobile-user-image"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = userProfile;
                      }}
                    />
                    <span className="mobile-user-name" style={{ color: "var(--color-oxford-blue)" }}>{userDetails.name}</span>
                  </li>

                  <li
                    className="mobile-link"
                    onClick={() => {
                      setIsOpen(false);
                      navigate('/profile');
                    }}
                  >
                    Edit Profile
                  </li>

                  <li
                    className="mobile-link logout"
                    onClick={() => {
                      setIsOpen(false);
                      handleLogout();
                    }}
                  >
                    Logout
                  </li>
                </>
              )}

              {!token && (
                <>
                  <li
                    className="mobile-link"
                    onClick={() => {
                      setIsOpen(false);
                      openModal("login");
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    Login
                  </li>
                  <li
                    className="mobile-link"
                    onClick={() => {
                      setIsOpen(false);
                      openModal("signup");
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    Register
                  </li>
                </>
              )}
            </ul>
          </div>
        )}
      </div>

      <Modalw
        isOpen={ModalOpen}
        closeModal={closeModal}
        otpVerification={otpVerification}
        isSignup={isSignup}
        setIsSignup={setIsSignup}
      />
      <Modal
        show={editProfile}
        size="m"
        onHide={handleEditProfileClose}
        centered
        className="edit-profile-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="modal-header-custom">
          <div className="edit-profile-header-wrap">
            <h5 className="edit-profile-title">Profile Settings</h5>
            <p className="edit-profile-subtitle">Manage your account details and password</p>
          </div>
          <div className="toggle-tabs">
            <Button
              variant="secondary"
              onClick={() => setColorChange("Edit Account")}
              className={`toggle-btn ${ColorChange === "Edit Account" ? "active" : ""}`}
            >
              Edit Account
            </Button>
            <Button
              variant="secondary"
              onClick={() => setColorChange("Edit Password")}
              className={`toggle-btn ${ColorChange === "Edit Password" ? "active" : ""}`}
            >
              Change Password
            </Button>
          </div>
        </Modal.Header>

        {ColorChange === "Edit Account" ? (
          <>
            <Modal.Body className="modal-body-custom">
              <div className="form-section-title">Basic Information</div>
              <Form.Group controlId="formName" className="form-group-custom">
                <Form.Label>Username / Name</Form.Label>
                <Form.Control
                  className="profile-input"
                  type="text"
                  placeholder="Enter name"
                  name="name"
                  value={userData.name}
                  onChange={handleChange}
                />
                {Error.name && <p className="error-text">{Error.name}</p>}
              </Form.Group>

              <Form.Group controlId="formFirstName" className="form-group-custom">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  className="profile-input"
                  type="text"
                  placeholder="Enter first name"
                  name="firstName"
                  value={userData.firstName || ""}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group controlId="formMiddleName" className="form-group-custom">
                <Form.Label>Middle Name</Form.Label>
                <Form.Control
                  className="profile-input"
                  type="text"
                  placeholder="Enter middle name"
                  name="middleName"
                  value={userData.middleName || ""}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group controlId="formLastName" className="form-group-custom">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  className="profile-input"
                  type="text"
                  placeholder="Enter last name"
                  name="lastName"
                  value={userData.lastName || ""}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group controlId="formPhone" className="form-group-custom">
                <Form.Label>Phone Number</Form.Label>
                <div className="d-flex align-items-center" style={{ border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
                  <div
                    style={{
                      padding: '0 10px',
                      backgroundColor: '#f3f4f6',
                      borderRight: '1px solid #e5e7eb',
                      color: '#4b5563',
                      fontSize: '1rem',
                      height: '48px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '55px',
                      fontWeight: '500'
                    }}
                  >
                    +91
                  </div>
                  <div className="d-flex align-items-center" style={{ flex: 1, backgroundColor: '#fff', paddingLeft: '15px' }}>
                    <AiOutlinePhone size={20} color="#6b7280" />
                    <Form.Control
                      className="profile-input"
                      type="number"
                      placeholder="Enter phone number"
                      name="phone"
                      value={userData.phone}
                      onChange={handleChange}
                      style={{ border: 'none', outline: 'none', flex: 1, height: '48px', margin: 0, paddingLeft: '10px' }}
                    />
                  </div>
                </div>
                {(Error.phone || Error.phoneNumber) && (
                  <p className="error-text">{Error.phone || Error.phoneNumber}</p>
                )}
              </Form.Group>

              <Form.Group controlId="formImage" className="form-group-custom">
                <Form.Label>Upload Image/Document</Form.Label>

                <Form.Control
                  type="file"
                  name="image"
                  ref={imageUploadRef}
                  onChange={handleImageUpload}
                  style={{ display: "none" }}
                  accept=".jpg, .jpeg, .png, .pdf"
                />

                {imageLoading ? (
                  <div className="loader-container">
                    <img src={loader} alt="Loading..." />
                    <p>Uploading...</p>
                  </div>
                ) : uploadedImageUrl || userData.image ? (
                  <div className="preview-wrapper">
                    <div
                      className="preview-close"
                      onClick={() => {
                        setUploadedImageUrl("");
                        setuserData((prev) => ({ ...prev, image: "" }));
                      }}
                    >
                      <img src={close} alt="Delete" width={20} />
                    </div>

                    {/\.(jpg|jpeg|png)$/i.test(uploadedImageUrl || userData.image) ? (
                      <img
                        src={uploadedImageUrl || userData.image}
                        alt="Preview"
                        className="preview-image"
                      />
                    ) : (
                      <iframe
                        src={getDocumentPreviewUrl(uploadedImageUrl || userData.image)}
                        className="preview-document"
                        title="Document Preview"

                        onError={() =>
                          setError((prev) => ({
                            ...prev,
                            image: "Failed to load document",
                          }))
                        }
                      />
                    )}
                  </div>
                ) : (
                  <div
                    className="upload-placeholder"
                    onClick={() => imageUploadRef.current.click()}
                  >
                    <img src={upload} width={50} alt="Upload" />
                    <p className="upload-title">Click to upload image/document</p>
                    {/* <span className="upload-subtitle">Supported: JPG, PNG, PDF</span> */}
                  </div>
                )}
                {Error.image && <p className="error-text">{Error.image}</p>}
              </Form.Group>
            </Modal.Body>

            <Modal.Footer className="modal-footer-custom">
              <Button variant="secondary" className="profile-btn-cancel" onClick={handleEditClose}>
                Close
              </Button>
              <Button disabled={imageLoading} variant="dark" className="profile-btn-save" onClick={editUser}>
                Update
              </Button>
            </Modal.Footer>
          </>
        ) : (
          <>
            <Modal.Body className="modal-body-custom">
              <div className="form-section-title">Security</div>
              <Form.Group controlId="formPassword" className="form-group-custom">
                <Form.Label>Current Password</Form.Label>
                <div className="password-container">
                  <Form.Control
                    className="profile-input"
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter current password"
                    name="password"
                    value={userData.password}
                    onChange={handlePasswordChange}
                  />
                  <span onClick={() => setShowPassword(!showPassword)} className="icon-eye">
                    {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                  </span>
                </div>
                {Error.password && <p className="error-text">{Error.password}</p>}
              </Form.Group>

              <Form.Group controlId="formNewPassword" className="form-group-custom">
                <Form.Label>New Password</Form.Label>
                <div className="password-container">
                  <Form.Control
                    className="profile-input"
                    type={showNewPassword ? "text" : "password"}
                    placeholder="Enter new password"
                    name="newPassword"
                    value={userData.newPassword}
                    onChange={handleNewPasswordChange}
                  />
                  <span onClick={() => setShowNewPassword(!showNewPassword)} className="icon-eye">
                    {showNewPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                  </span>
                </div>
                {(Error.newPassword || Error.match) && (
                  <p className="error-text">{Error.newPassword || Error.match}</p>
                )}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer className="modal-footer-custom">
              <Button variant="secondary" className="profile-btn-cancel" onClick={handleEditClose}>
                Close
              </Button>
              <Button variant="dark" className="profile-btn-save" onClick={changePassword}>
                Update
              </Button>
            </Modal.Footer>
          </>
        )}
      </Modal>

    </>
  );
};

export default Navbar;

